import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__ from "@radix-ui/react-slot";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
const badgeVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)("inline-flex items-center select-none justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden", {
    variants: {
        variant: {
            default: "border-brand-primary/[0.15] bg-brand-primary/20 text-brand-primary [a&]:hover:bg-brand-primary/[0.23] transition-all",
            secondary: "border-transparent bg-[rgba(163,163,163,0.1)] text-foreground/70 [a&]:hover:bg-white/10 transition-all",
            destructive: "border-alert-background bg-alert-background/70 text-alert-primary [a&]:hover:bg-alert-background/80 transition-all",
            warning: "border-amber-500/[0.15] bg-amber-500/20 text-amber-500 [a&]:hover:bg-amber-500/[0.23] transition-all",
            outline: "text-foreground bg-grayscale-dark [a&]:hover:text-foreground/50 transition-all",
            headless: ""
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function Badge({ className, variant, asChild = false, ...props }) {
    const Comp = asChild ? __WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__.Slot : "span";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Comp, {
        "data-slot": "badge",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(badgeVariants({
            variant
        }), className),
        ...props
    });
}
export { Badge, badgeVariants };
